function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.weak-map.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.error.cause.js";
import { defineIntegration, supportsReportingObserver, GLOBAL_OBJ, getClient, withScope, captureMessage } from '@sentry/core';
var WINDOW = GLOBAL_OBJ;
var INTEGRATION_NAME = 'ReportingObserver';
var SETUP_CLIENTS = new WeakMap();
var _reportingObserverIntegration = function _reportingObserverIntegration() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var types = options.types || ['crash', 'deprecation', 'intervention'];

  /** Handler for the reporting observer. */
  function handler(reports) {
    if (!SETUP_CLIENTS.has(getClient())) {
      return;
    }
    var _iterator = _createForOfIteratorHelper(reports),
      _step;
    try {
      var _loop = function _loop() {
        var report = _step.value;
        withScope(function (scope) {
          scope.setExtra('url', report.url);
          var label = "ReportingObserver [".concat(report.type, "]");
          var details = 'No details available';
          if (report.body) {
            // Object.keys doesn't work on ReportBody, as all properties are inherited
            var plainBody = {};

            // eslint-disable-next-line guard-for-in
            for (var prop in report.body) {
              plainBody[prop] = report.body[prop];
            }
            scope.setExtra('body', plainBody);
            if (report.type === 'crash') {
              var body = report.body;
              // A fancy way to create a message out of crashId OR reason OR both OR fallback
              details = [body.crashId || '', body.reason || ''].join(' ').trim() || details;
            } else {
              var _body = report.body;
              details = _body.message || details;
            }
          }
          captureMessage("".concat(label, ": ").concat(details));
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return {
    name: INTEGRATION_NAME,
    setupOnce: function setupOnce() {
      if (!supportsReportingObserver()) {
        return;
      }
      var observer = new WINDOW.ReportingObserver(handler, {
        buffered: true,
        types: types
      });
      observer.observe();
    },
    setup: function setup(client) {
      SETUP_CLIENTS.set(client, true);
    }
  };
};

/**
 * Reporting API integration - https://w3c.github.io/reporting/
 */
var reportingObserverIntegration = defineIntegration(_reportingObserverIntegration);
export { reportingObserverIntegration };